import { Activity, Database, Grid2x2, Mic, Radio, Users } from 'lucide-react';
import { useState } from 'react';
import { BackupTab } from './BackupTab';
import { ChannelsTab } from './ChannelsTab';
import { PanelsTab } from './PanelsTab';
import { RecordingsTab } from './RecordingsTab';
import { StatusTab } from './StatusTab';
import { UsersTab } from './UsersTab';

type Tab = 'users' | 'channels' | 'panels' | 'recordings' | 'status' | 'backup';

const TABS: { id: Tab; label: string; icon: typeof Users }[] = [
  { id: 'users', label: 'Users', icon: Users },
  { id: 'channels', label: 'Channels', icon: Radio },
  { id: 'panels', label: 'Panels', icon: Grid2x2 },
  { id: 'recordings', label: 'Recordings', icon: Mic },
  { id: 'status', label: 'Status', icon: Activity },
  { id: 'backup', label: 'Backup', icon: Database },
];

export function AdminApp() {
  const [tab, setTab] = useState<Tab>('users');
  return (
    <div className="admin card" style={{ padding: 0, overflow: 'hidden' }}>
      <nav className="admin__nav">
        {TABS.map((t) => (
          <button key={t.id} className={`navitem ${tab === t.id ? 'navitem--on' : ''}`} onClick={() => setTab(t.id)}>
            <t.icon size={18} /> {t.label}
          </button>
        ))}
      </nav>
      <div className="admin__content">
        {tab === 'users' && <UsersTab />}
        {tab === 'channels' && <ChannelsTab />}
        {tab === 'panels' && <PanelsTab />}
        {tab === 'recordings' && <RecordingsTab />}
        {tab === 'status' && <StatusTab />}
        {tab === 'backup' && <BackupTab />}
      </div>
    </div>
  );
}
